(() => {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('cfb_success')) return;

  // Keep the confirmed-success URL long enough for Shopify's native page view
  // event, then prevent refreshes from counting the same lead again.
  window.setTimeout(() => {
    url.searchParams.delete('cfb_success');
    url.searchParams.delete('cfb_build');
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  }, 2000);
})();
